import * as apiTo from '@/modular-api'

export default {
  namespaced: true,

  state: () => ({
    totalRows: 0,
    rowsSelected: [],
    selectAll: false,
    statuses: [],
    selectedDepartment: null,
    refreshCardsHandler: 0, // whenever we change this, departmentInfo and totalInfo cards will re-fetch
    filterInProgress: false
  }),

  mutations: {
    setTotalRows: (state, payload) => (state.totalRows = payload),
    setRowsSelected: (state, payload) => (state.rowsSelected = payload),
    setSelectAll: (state, payload) => (state.selectAll = payload),
    setStatuses: (state, payload) => (state.statuses = payload),
    setSelectedDepartment: (state, payload) => (state.selectedDepartment = payload),
    refreshCards: state => state.refreshCardsHandler++,
    setFilterInProgress: (state, payload) => (state.filterInProgress = payload)
  },

  actions: {
    getAndSetStatuses({ commit }) {
      return apiTo.GET_SUB_PERIOD_RECOMMENDATION_STATUSES().then(({ data }) => commit('setStatuses', data.result))
    }
  }
}
